<script setup>
import ButtonLink from '@/Components/Buttons/ButtonLink.vue';
import { useBg } from '@/stores/bgStore';
import { useIntersectionObserver } from '@vueuse/core';
import { ref } from 'vue';
import ReviewCard from './ReviewCard.vue';

const bg = useBg();
const target = ref(null);
useIntersectionObserver(target, ([{ isIntersecting }], observerElement) => {
    isIntersecting ? bg.add('reviews') : bg.remove('reviews');
});

const props = defineProps({
    title: String,
    reviews: Object,
    amount_reviews: String,
    button_label: String,
    external_url: String,
    intended_url: String,
    review_url: String,
});
</script>

<template>
    <div ref="target" class="container my-15 md:my-30" v-if="reviews && reviews.length">
        <div class="flex justify-center">
            <h2 class="text-2xl lg:text-[64px] font-bold mb-8 md:mb-16">Recensies</h2>
        </div>

        <div
            class="relative gap-16"
            :class="{
                'columns-1 sm:columns-2 md:columns-3': amount_reviews != 3,
                'grid md:grid-cols-2 lg:grid-cols-3': amount_reviews == 3,
            }"
        >
            <ReviewCard v-for="review in reviews" :key="review.id" :review="review" />
        </div>

        <div class="flex justify-center mt-8 md:mt-16">
            <ButtonLink :label="$t('Alle recensies')" :href="review_url" />
        </div>
    </div>
</template>
